import { useQuery } from '@tanstack/react-query'

import { commonService } from 'src/services'
import { QUERY_KEYS } from 'src/constants'

export const useGetHomePageSetings = () => {
  return useQuery([QUERY_KEYS.GET_HOME_PAGE_SETTINGS], () => commonService.getHomePageSetings(), {})
}
